<template>
  <div class="main-wrap">
    <div>
      <img src="../../assets/images/winterGame/guide_icon.png" alt="">
      战队海报
    </div>
    <div>战队创建成功</div>
    <div>
      学霸们四处冲冲冲
      <img src="../../assets/images/winterGame/guide_icon.png" alt="">
    </div>
    <div>浙江省温州市温岭服务中心</div>
    <div>请添加战队成员</div>
    <img src="../../assets/images/winterGame/guide_icon.png" alt="">
    <div class="btn">+添加战队成员</div>
  </div>
</template>

<script>
import img1 from '../../assets/images/winterGame/team_icon.png'
import img2 from '../../assets/images/winterGame/member_icon.png'
import img3 from '../../assets/images/winterGame/achiev_icon_gray.png'
export default {
  data () {
    return {
      blockList:[{
        img:img1,
        text:'战队建设',
        url:'/winterGame/memberRecord'
      },{
        img:img2,
        text:'出战名单',
      },{
        img:img3,
        text:'成员战绩',
      }],
    }
  },
  created() {
    const { agentId, openId } = this.$route.query || {}
    let params = { agentId, openId }
    this.userInfoId = localStorage.setItem("userInfoId", JSON.stringify(params || {})) || {}
    console.log('小程序携带参数', params)
    this.initData()
  },
  mounted() {

  },
  methods: {
    initData(){

    },
    handleClick(){
      this.$router.push('/winterGame/memberRecord')
    }
  }
};
</script>

<style lang="less">
.main-wrap {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  padding: 46px 32px;
  .list{
    display: flex;
    justify-content: space-between;
    font-size: 32px;
    color: #323232;
    line-height: 44px;
    .item{
      min-width: 218px;
      text-align: center;
      p{
        margin: 0;
      }
      img{
        width: 96px;
        height: 96px;
        margin-bottom: 10px;
      }
    }
  }
  .guide-wrap{
    font-size: 32px;
    color: #58ABF6;
    line-height: 44px;
    img{
      width: 112px;
      margin-left: 98px;
      margin-bottom: 6px;
    }
    p{
      margin: 0;
      text-align: center;
    }
  }
}
</style>
